export default {"src":"/_next/static/media/peaceOfMind.2a56a26c.svg","height":25,"width":23,"blurWidth":0,"blurHeight":0};